// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------

import { excluirInteresse } from "../../../services/excluirInteresseService";

export const useExcluirInteresse = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const excluir = async (id: number) => {
    setIsLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const excluirDados = await excluirInteresse(id);
      if (excluirDados) {
        setSuccess("Interesse excluído com sucesso!");
      } else {
        setError(
          "Não foi possível excluir este Interesse, por favor tente novamente"
        );
      }
    } catch (error) {
      console.error(error);
      setError(
        "Ocorreu um erro ao excluri este interrese, por favor tente mais tarde!"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { excluir, isLoading, error, success, resetError, resetSuccess };
};
